import React from 'react';

import MotifTextLink from '@ey/motif-react-wrapper/TextLink';

const TextLink = ({label, ...rest}) => <MotifTextLink {...rest}>{label}</MotifTextLink>;

TextLink.propTypes = {};

export default TextLink;
